import Dialog from './Dialog';
import Character from '../Character';
import common from '../common';
import Text from './Text';

export default class AlertDialog extends Dialog {
	constructor(title, body, mood) {
		super(710, -1, null);
		this.setTitleText(title);
		this.setBodyText(body);

		this._character = null;
		this._mood = mood;

		this.signals = {};
		this.signals.close = new P3.utils.MiniSignal();

		this.init();
	}

	init() {
		const advisorBG = new PIXI.Sprite(P3.assets.texture(`disaster_strip_${common.selectedLevel}`));

		advisorBG.position.set(50, 110);
		advisorBG.scale.set(0.5);
		this._panel.body.addChild(advisorBG);

		// let disasterIconBG = new PIXI.Sprite(P3.assets.texture('disaster_icon_bg'));
		// this._panel.body.addChild(disasterIconBG);
		// disasterIconBG.position.set(advisorBG.x + advisorBG.width, advisorBG.y);

		const disasterIcon = new PIXI.Sprite(P3.assets.texture(`icon_${common.selectedLevel}`));

		disasterIcon.anchor.set(0, 0.5);
		disasterIcon.position.set(advisorBG.x + advisorBG.width + 5, advisorBG.y + advisorBG.height * 0.5);

		const disasterIconBG = new PIXI.Graphics();

		disasterIconBG.beginFill(0x3e120c, 1);
		disasterIconBG.drawRect(0, 0, disasterIcon.width + 10, advisorBG.height);
		disasterIconBG.endFill();
		disasterIconBG.position.set(advisorBG.x + advisorBG.width, advisorBG.y);

		this._panel.body.addChild(disasterIconBG);
		this._panel.body.addChild(disasterIcon);

		this._character = new Character();
		this._character.position.set(140, advisorBG.y + advisorBG.height);
		this._panel.body.addChild(this._character);
		this._character.playAnimation(this._mood);
		this._character.update(0);

		const pictureMask = new PIXI.Graphics();

		pictureMask.beginFill(0x0);
		pictureMask.drawRect(0, 0, 150, this._character.height);
		pictureMask.endFill();
		pictureMask.position.set(70, this._character.y - this._character.height);
		this._panel.body.addChild(pictureMask);
		this._character.mask = pictureMask;

		this._panel.body.text.y += 170;
		this._panel.body.text.x += 10;

		this._panel.body.okButton = common.buttonFactory.createButton({
			normal: { textureName: 'btn_blue_fill_large_9slice_out', width: 300, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
			over: { textureName: 'btn_blue_fill_large_9slice_over', width: 300, height: 75, left: 35, top: 35, right: 35, bottom: 35 },
		});
		this._panel.body.okButton.signals.click.add(this.onCloseButtonClick, this);
		this._panel.body.okButton.position.set(this._panel.body.width * 0.5, this._panel.body.text.y + this._panel.body.text.height + 80);
		this._panel.body.addChild(this._panel.body.okButton);

		this._panel.body.okButton.label = new Text('gui.general.options.ok', { font: '32px', fontWeight: 'bold', align: 'left', tint: 0xFFFFFF });
		this._panel.body.okButton.label.anchor.set(0.5);
		this._panel.body.okButton.addChild(this._panel.body.okButton.label);
		this.resize();

		this._panel.body.okButton.accessibleTitle = this._panel.body.okButton.label.text;

		this._closeButton.signals.click.add(this.onCloseButtonClick, this);
	}

	onCloseButtonClick() {
		this.visible = false;
		common.popupOpen = false;
		this.signals.close.dispatch();
	}

	destroy() {
		super.destroy({ children: true });
		this._character.destroy();
	}

	resize() {
		if (!this._panel.body.okButton) {
			return;
		}
		super.resize(this._panel.body.okButton.y + this._panel.body.okButton.height + 25);
	}

	setBodyText(text) {
		super.setBodyText(text);

		this._panel.body.okButton && this._panel.body.okButton.position.set(this._panel.body.width * 0.5, this._panel.body.text.y + this._panel.body.text.height + 80);
		this.resize();
	}

	update() {
		if (this._character) {
			this._character.update();
		}
	}

	get dialog() {
		return this._dialog;
	}

	get character() {
		return this._character;
	}
}
